import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  
  private hideScrollSource = new Subject<boolean>();
  hideScroll$ = this.hideScrollSource.asObservable();

  hideScroll(hide: boolean) {
    this.hideScrollSource.next(hide);
  }
}
